// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Основные анимации для Telegram Loader */
@keyframes float {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(180deg); }
}

@keyframes pulse {
  0%, 100% { opacity: 0.3; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.1); }
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes progressFill {
  0% { width: 0%; }
  25% { width: 30%; }
  50% { width: 60%; }
  75% { width: 85%; }
  100% { width: 100%; }
}

@keyframes fadeInOut {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 1; }
}

@keyframes slideIn {
  from { 
    opacity: 0; 
    transform: translateY(20px); 
  }
  to { 
    opacity: 1; 
    transform: translateY(0); 
  }
}

/* Фоновые анимированные элементы */
.telegram-bg-animation {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

.floating-circle {
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(45deg, 
    var(--tg-theme-button-color, #007aff), 
    var(--tg-theme-accent-text-color, #007aff)
  );
  opacity: 0.1;
  animation: float 6s ease-in-out infinite;
}

.circle-1 {
  width: 60px;
  height: 60px;
  top: 20%;
  left: 10%;
  animation-delay: 0s;
}

.circle-2 {
  width: 40px;
  height: 40px;
  top: 60%;
  right: 15%;
  animation-delay: 2s;
}

.circle-3 {
  width: 80px;
  height: 80px;
  bottom: 30%;
  left: 20%;
  animation-delay: 4s;
}

.circle-4 {
  width: 30px;
  height: 30px;
  top: 40%;
  right: 30%;
  animation-delay: 1s;
}

/* Главный логотип */
.telegram-logo-container {
  z-index: 10;
  animation: slideIn 0.8s ease-out;
}

.telegram-logo {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, 
    var(--tg-theme-button-color, #007aff) 0%, 
    var(--tg-theme-accent-text-color, #0056d3) 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  animation: pulse 2s ease-in-out infinite;
  box-shadow: 
    0 8px 32px rgba(0, 122, 255, 0.2),
    0 4px 16px rgba(0, 122, 255, 0.1);
}

.telegram-inner-circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: var(--tg-theme-button-color, #007aff);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.telegram-plane {
  animation: rotate 8s linear infinite;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Прогресс бар */
.telegram-progress-container {
  width: 200px;
  z-index: 10;
  animation: slideIn 1s ease-out 0.3s both;
}

.telegram-progress-bar {
  width: 100%;
  height: 4px;
  background: var(--tg-theme-section-separator-color, rgba(0, 122, 255, 0.1));
  border-radius: 2px;
  overflow: hidden;
  position: relative;
}

.telegram-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, 
    var(--tg-theme-button-color, #007aff) 0%, 
    var(--tg-theme-accent-text-color, #0056d3) 100%
  );
  border-radius: 2px;
  animation: progressFill 3s ease-in-out infinite;
  box-shadow: 0 0 10px var(--tg-theme-button-color, #007aff);
}

/* Контейнер текста */
.telegram-text-container {
  z-index: 10;
  text-align: center;
  animation: slideIn 1.2s ease-out 0.6s both;
}

/* Пульсирующие точки */
.telegram-dots {
  display: flex;
  gap: 8px;
  z-index: 10;
  animation: slideIn 1.4s ease-out 0.9s both;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--tg-theme-button-color, #007aff);
  animation: fadeInOut 1.5s ease-in-out infinite;
}

.dot-1 {
  animation-delay: 0s;
}

.dot-2 {
  animation-delay: 0.3s;
}

.dot-3 {
  animation-delay: 0.6s;
}

/* Дополнительные эффекты для темной темы */
@media (prefers-color-scheme: dark) {
  .floating-circle {
    opacity: 0.05;
  }
  
  .telegram-logo {
    box-shadow: 
      0 8px 32px rgba(0, 122, 255, 0.3),
      0 4px 16px rgba(0, 122, 255, 0.2);
  }
}

/* Адаптивность */
@media (max-width: 480px) {
  .telegram-logo {
    width: 60px;
    height: 60px;
  }
  
  .telegram-inner-circle {
    width: 45px;
    height: 45px;
  }
  
  .telegram-progress-container {
    width: 160px;
  }
  
  .floating-circle {
    opacity: 0.08;
  }
  
  .circle-1 { width: 40px; height: 40px; }
  .circle-2 { width: 30px; height: 30px; }
  .circle-3 { width: 50px; height: 50px; }
  .circle-4 { width: 20px; height: 20px; }
}

/* Улучшенная производительность */
.telegram-bg-animation,
.telegram-logo,
.telegram-progress-fill,
.dot {
  will-change: transform, opacity;
}

/* Плавные переходы для изменения темы */
* {
  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
} `, "",{"version":3,"sources":["webpack://./src/components/TelegramLoader.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,WAAW,uCAAuC,EAAE;EACpD,MAAM,2CAA2C,EAAE;AACrD;;AAEA;EACE,WAAW,YAAY,EAAE,mBAAmB,EAAE;EAC9C,MAAM,UAAU,EAAE,qBAAqB,EAAE;AAC3C;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,KAAK,SAAS,EAAE;EAChB,MAAM,UAAU,EAAE;EAClB,MAAM,UAAU,EAAE;EAClB,MAAM,UAAU,EAAE;EAClB,OAAO,WAAW,EAAE;AACtB;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB;;;GAGC;EACD,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB;;;GAGC;EACD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC;;qCAEmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,WAAW;EACX,2EAA2E;EAC3E,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ;;;GAGC;EACD,kBAAkB;EAClB,+CAA+C;EAC/C,0DAA0D;AAC5D;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iDAAiD;EACjD,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,2CAA2C;AAC3C;EACE;IACE,aAAa;EACf;;EAEA;IACE;;uCAEmC;EACrC;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA,YAAY,WAAW,EAAE,YAAY,EAAE;EACvC,YAAY,WAAW,EAAE,YAAY,EAAE;EACvC,YAAY,WAAW,EAAE,YAAY,EAAE;EACvC,YAAY,WAAW,EAAE,YAAY,EAAE;AACzC;;AAEA,kCAAkC;AAClC;;;;EAIE,+BAA+B;AACjC;;AAEA,wCAAwC;AACxC;EACE,+EAA+E;AACjF","sourcesContent":["/* Основные анимации для Telegram Loader */\n@keyframes float {\n  0%, 100% { transform: translateY(0px) rotate(0deg); }\n  50% { transform: translateY(-20px) rotate(180deg); }\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 0.3; transform: scale(1); }\n  50% { opacity: 1; transform: scale(1.1); }\n}\n\n@keyframes rotate {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n@keyframes progressFill {\n  0% { width: 0%; }\n  25% { width: 30%; }\n  50% { width: 60%; }\n  75% { width: 85%; }\n  100% { width: 100%; }\n}\n\n@keyframes fadeInOut {\n  0%, 100% { opacity: 0.5; }\n  50% { opacity: 1; }\n}\n\n@keyframes slideIn {\n  from { \n    opacity: 0; \n    transform: translateY(20px); \n  }\n  to { \n    opacity: 1; \n    transform: translateY(0); \n  }\n}\n\n/* Фоновые анимированные элементы */\n.telegram-bg-animation {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.floating-circle {\n  position: absolute;\n  border-radius: 50%;\n  background: linear-gradient(45deg, \n    var(--tg-theme-button-color, #007aff), \n    var(--tg-theme-accent-text-color, #007aff)\n  );\n  opacity: 0.1;\n  animation: float 6s ease-in-out infinite;\n}\n\n.circle-1 {\n  width: 60px;\n  height: 60px;\n  top: 20%;\n  left: 10%;\n  animation-delay: 0s;\n}\n\n.circle-2 {\n  width: 40px;\n  height: 40px;\n  top: 60%;\n  right: 15%;\n  animation-delay: 2s;\n}\n\n.circle-3 {\n  width: 80px;\n  height: 80px;\n  bottom: 30%;\n  left: 20%;\n  animation-delay: 4s;\n}\n\n.circle-4 {\n  width: 30px;\n  height: 30px;\n  top: 40%;\n  right: 30%;\n  animation-delay: 1s;\n}\n\n/* Главный логотип */\n.telegram-logo-container {\n  z-index: 10;\n  animation: slideIn 0.8s ease-out;\n}\n\n.telegram-logo {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, \n    var(--tg-theme-button-color, #007aff) 0%, \n    var(--tg-theme-accent-text-color, #0056d3) 100%\n  );\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  animation: pulse 2s ease-in-out infinite;\n  box-shadow: \n    0 8px 32px rgba(0, 122, 255, 0.2),\n    0 4px 16px rgba(0, 122, 255, 0.1);\n}\n\n.telegram-inner-circle {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background: var(--tg-theme-button-color, #007aff);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.telegram-plane {\n  animation: rotate 8s linear infinite;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Прогресс бар */\n.telegram-progress-container {\n  width: 200px;\n  z-index: 10;\n  animation: slideIn 1s ease-out 0.3s both;\n}\n\n.telegram-progress-bar {\n  width: 100%;\n  height: 4px;\n  background: var(--tg-theme-section-separator-color, rgba(0, 122, 255, 0.1));\n  border-radius: 2px;\n  overflow: hidden;\n  position: relative;\n}\n\n.telegram-progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, \n    var(--tg-theme-button-color, #007aff) 0%, \n    var(--tg-theme-accent-text-color, #0056d3) 100%\n  );\n  border-radius: 2px;\n  animation: progressFill 3s ease-in-out infinite;\n  box-shadow: 0 0 10px var(--tg-theme-button-color, #007aff);\n}\n\n/* Контейнер текста */\n.telegram-text-container {\n  z-index: 10;\n  text-align: center;\n  animation: slideIn 1.2s ease-out 0.6s both;\n}\n\n/* Пульсирующие точки */\n.telegram-dots {\n  display: flex;\n  gap: 8px;\n  z-index: 10;\n  animation: slideIn 1.4s ease-out 0.9s both;\n}\n\n.dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--tg-theme-button-color, #007aff);\n  animation: fadeInOut 1.5s ease-in-out infinite;\n}\n\n.dot-1 {\n  animation-delay: 0s;\n}\n\n.dot-2 {\n  animation-delay: 0.3s;\n}\n\n.dot-3 {\n  animation-delay: 0.6s;\n}\n\n/* Дополнительные эффекты для темной темы */\n@media (prefers-color-scheme: dark) {\n  .floating-circle {\n    opacity: 0.05;\n  }\n  \n  .telegram-logo {\n    box-shadow: \n      0 8px 32px rgba(0, 122, 255, 0.3),\n      0 4px 16px rgba(0, 122, 255, 0.2);\n  }\n}\n\n/* Адаптивность */\n@media (max-width: 480px) {\n  .telegram-logo {\n    width: 60px;\n    height: 60px;\n  }\n  \n  .telegram-inner-circle {\n    width: 45px;\n    height: 45px;\n  }\n  \n  .telegram-progress-container {\n    width: 160px;\n  }\n  \n  .floating-circle {\n    opacity: 0.08;\n  }\n  \n  .circle-1 { width: 40px; height: 40px; }\n  .circle-2 { width: 30px; height: 30px; }\n  .circle-3 { width: 50px; height: 50px; }\n  .circle-4 { width: 20px; height: 20px; }\n}\n\n/* Улучшенная производительность */\n.telegram-bg-animation,\n.telegram-logo,\n.telegram-progress-fill,\n.dot {\n  will-change: transform, opacity;\n}\n\n/* Плавные переходы для изменения темы */\n* {\n  transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
